<div class="layout-container" [ngClass]="containerClass">
    <app-sidebar (grandparentlogoutclick)="showlogoutconfirmationdialog()"></app-sidebar>
    <div class="layout-content-wrapper">
        <app-topbar></app-topbar>
        <!-- <app-breadcrumb class="content-breadcrumb"></app-breadcrumb> -->
        <router-outlet></router-outlet>
        <div class="layout-mask"></div>
    </div>
    <!-- <app-profilemenu></app-profilemenu>
    <app-config></app-config> -->
</div>


<p-dialog [(visible)]="logoutconfirmationdialog" [modal]="true" [style]="{ width: '500px' }" [draggable]="false"
    [resizable]="false" [closable]="false">
    <div class="text-center">
        <div class="warning-icon"></div>
        <p class="title">{{ 'LAYOUT.LOGOUT_CONFIRM_TITLE' | translate }}</p>
        <p class="text">{{ 'LAYOUT.LOGOUT_CONFIRM_BODY' | translate }}</p>
        <div class="d-flex justify-content-center gap-3 mt-4">
            <button class="btn btn-outline-secondary" (click)="logoutconfirmationdialog=false">{{ 'COMMON.NO' | translate }}</button>
            <button class="btn btn-action" (click)="logout()">{{ 'COMMON.LOGOUT' | translate }}</button>
        </div>
    </div>
</p-dialog>